jQuery.validator.addMethod( "zipcode", function( value, element ) {

	// Some quick simple tests to prevent needless work
	if ( this.optional( element ) ) {
		return true;
	}

	var countryCode = $('[data-zipcode-country="' + element.id + '"]').find(':selected').data('code');
	if( ! countryCode ){
		console.error('No country code found');
	}

	// Remove spaces and to upper case
	var zipcode = value.replace( / /g, "" ).toUpperCase();
	var minLength = 4;
	if ( zipcode.length < minLength ) {
		return false;
	}

	var patterns = {
		"NL": "^[1-9][0-9]{3}[\\s]?[A-Za-z]{2}$",
		"BE": "^[0-9]{4}$",
		"DE": "^[0-9]{5}$",
	};

	var patern = patterns[ countryCode.toUpperCase() ];
	if ( typeof patterns !== "undefined" ) {
		var zipcodeRegexp = new RegExp( patern, "i" );
		if ( !( zipcodeRegexp.test( zipcode ) ) ) {
			return false; // Invalid country specific format
		}
	}

	return true;
}, jQuery.validator.messages.zipcode);
